import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dropzone from 'react-dropzone';
import Papa from 'papaparse';

import { CSV_TEMPLATE_SCHEMA } from '../../../../constants/ddny';

import { formatFilesize } from '../../../../utils/formatting';

import styles from './_styles/ImportInput.module.scss';

const allActionCreators = Object.assign({});

export class ImportInput extends Component {

	constructor(props) {
		super(props);

		this.state = {

			inputCSVFile: null,
		
			errorCSVFile: '',
			errorCSVSchema: '', 
		
			dragCount: 0,
		};

		this.fileDropRef = React.createRef();
	}

	dragEnterInput(evt) {
		for(const tp of evt.dataTransfer.types) {
			if(tp === 'Files') {
				this.setState({ dragCount: this.state.dragCount + 1 });
				break;
			}
		}
	}

	dragLeaveInput(evt) {
		this.setState({ dragCount: Math.max(this.state.dragCount - 1, 0) });
	}

	getErrorBulkCSVImport(file, mbSizeLimit = 100) {

		if(!file) {
			return '';
		}
	
		const flMime = file.type;
		const flSize = file.size;
	
		const validMimes = [
			'text/csv',
		];
	
		// Default upload limit: 100MB
		const maxFileSize = mbSizeLimit * 1024 * 1024; 
	
		if(!validMimes.includes(flMime)) {
			return 'File must be a CSV';
		} 
		if(flSize > maxFileSize) {
			return 'File must be less than 100MB. It\'s a CSV file, let\'s be reasonable here.';
		}
	
		return '';
	}

	async dragDropInput(files) {

		if(files.length > 1) {
			this.setState({
				errorCSVFile: 'Can only upload one file at a time',
				dragCount: 0,
			});
			return null;
		}

		if(files.length === 1) {
			const fileError = this.getErrorBulkCSVImport(files[0], 10);
			this.setState({
				inputCSVFile: fileError === '' ? files[0] : null,
				errorCSVFile: fileError,
				dragCount: 0,
			}, () => {

				if(this.state.inputCSVFile) {

					Papa.parse(this.state.inputCSVFile, {
						worker: true,
						header: false,
						skipEmptyLines: true,
						preview: 1,
						complete: (results) => {

							try {

							const missingFields = [];
							const requiredFields = [
								'Vendor Style',
							];

							for(const field of requiredFields) {
								const headerKeys = results.data[0];
								if(!headerKeys.includes(field)) {
									missingFields.push(field);
								}
							}

							if(missingFields.length > 0) {
								this.setState({
								inputCSVFile: null,
								errorCSVSchema: `The following fields are required: ${missingFields.join(', ')}`,
								});
							} else {
								this.setState({
									errorCSVSchema: '',
								});
							}
						
							} catch(err) {
								this.setState({
									inputCSVFile: null,
									errorCSVFile: 'Invalid bulk import file',
								});
							}
						},
						error: (err) => {
							this.setState({
								inputCSVFile: null,
								errorCSVFile: 'Invalid bulk import file',
							});
						},
					});
				}
			});
		}
	}

	removeFile(evt) {
		evt.stopPropagation();
		this.setState({
			inputCSVFile: null,
			errorCSVFile: '',
			errorCSVSchema: '', 
		});
	}

	saveAction(evt) {
		if(evt) { evt.preventDefault(); }
		if(!this.validateAll()) {
			this.props.initiateUpload(this.state.inputCSVFile);
		}
	}

	validateAll(showErrors = false) {

		const csvError = (!this.state.inputCSVFile ? 'Please select a file to upload' : '') || this.getErrorBulkCSVImport(this.state.inputCSVFile, 10);

		const errorObj = {
			errorCSVFile: csvError,
			errorCSVSchema: this.state.errorCSVSchema,
		};
		if(showErrors) {
			this.setState(errorObj);
		}
		return csvError || this.state.errorCSVSchema || '';
	}

	downloadTemplate() {

		const firstRow = {};
		for(const col of CSV_TEMPLATE_SCHEMA) {
		  firstRow[col] = '';
		}
	
		const template = Papa.unparse([ firstRow ]);
		const templateData = new Blob([ template ], { type: 'text/csv;charset=utf-8;' });
		const templateURL = navigator.msSaveBlob ? navigator.msSaveBlob(templateData, `upload-template.csv`) : window.URL.createObjectURL(templateData);
	
		let tempLink = document.createElement('a');
		tempLink.href = templateURL;
		tempLink.setAttribute('download', `upload-template.csv`);
		tempLink.click();
	}

	render() {
		return <div className={styles.ImportInput}>
			
			<div className={styles.guidanceSection}>
				<div className={styles.guidanceTitle}>Bulk Import CSV</div>
				<div className={styles.guidanceSubtitle}>Upload product document, export, or <span className={styles.templateLink}  onClick={this.downloadTemplate.bind(this)}>download a template</span>.</div>
			</div>
            

			<div className={styles.dropzoneSection}>
				<Dropzone onDrop={acceptedFiles => this.dragDropInput(acceptedFiles)} disabled={this.state.inputCSVFile !== null}>
					{({getRootProps, getInputProps}) => (
						<section>
							<div {...getRootProps()}>
								<input {...getInputProps()} />
								<div 
									ref={this.fileDropRef}
									className={`${styles.dropWrapper} ${this.state.dragCount ? styles.hoverFile : ''}`}
									onDragEnter={this.dragEnterInput.bind(this)}
									onDragLeave={this.dragLeaveInput.bind(this)}>

									{this.state.inputCSVFile ?
										<div className={styles.dropFileDisplay}>
											<div className={styles.dropFileDetailsWrapper}>
												<div className={`${styles.nameLabel} EllipsisElement`}>{this.state.inputCSVFile.name}</div>
												<div className={styles.metaLabel}>{formatFilesize(this.state.inputCSVFile.size)}</div>
												<div className={styles.removeLabel} onClick={this.removeFile.bind(this)}>Remove</div>
											</div>
											<div className={styles.dropFileCloseWrapper} onClick={this.removeFile.bind(this)}>
												<div className='FlexCenter'>&times;</div>
											</div>
										</div> :
										<div className={styles.dropPrompt}>Drag and drop or click here to upload file.</div>
									}
										
									{this.state.errorCSVFile ?
										<div className={styles.dropError}>{this.state.errorCSVFile}</div> :
										null
									}

									{this.state.errorCSVSchema ?
										<div className={styles.dropError}>{`${this.state.errorCSVSchema}`}</div> :
										null
									}

									{!this.state.inputCSVFile ?
										<button 
										className={`${styles.dropButton} actionButton`}
										type='button'>
											{'Select File'}
										</button> :
										null
									}
								</div>
							</div>
						</section>
					)}
				</Dropzone>
			</div>

			<div className={styles.actionRow}>
				<button 
					className={`${styles.submitAction} actionButton`} 
					type='button'
					onClick={this.saveAction.bind(this)}
					disabled={this.validateAll()}>
					{'Next'}
				</button>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ImportInput);